module.exports = __webpack_public_path__ + "static/media/trustwallet.eebf3ae2.svg";